// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { ProductList } from "@/components/ProductList";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import heroImage from "@/assets/hero-service.png";

export const Route = createFileRoute("/$lang/services/")({
  head: () => ({
    meta: [
      { title: i18n.t("services/index:metaTitle", "Services — BIZU Space") },
      {
        name: "description",
        content: i18n.t("services/index:metaDesc",
          "BIZU Space services — aerospace manufacturing, T8 test facility and aerospace & systems engineering."
        ),
      },
      { property: "og:title", content: i18n.t("services/index:metaTitle", "Services — BIZU Space") },
      {
        property: "og:description",
        content: i18n.t("services/index:metaOgDesc",
          "Aerospace manufacturing, T8 test facility and aerospace & systems engineering."
        ),
      },
      { property: "og:url", content: "/services" },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/services" }],
  }),
  component: Services,
});

function Services() {
  const { t } = useTranslation("services/index");

  const services = [
    {
      code: "01",
      name: t("list.s1Title", "Aerospace and Systems Engineering"),
      desc: t("list.s1Desc",
        "Comprehensive engineering for launch vehicle development and launch operations, covering planning, safety analyses, mission simulations, and international-standard documentation."
      ),
      link: "/services/aerospace",
    },
    {
      code: "02",
      name: t("list.s2Title", "Aerospace Manufacturing"),
      desc: t("list.s2Desc",
        "Manufacturing of critical aerospace components using CNC machining, specialized welding, and in-house hydraulic testing to ensure structural integrity and reliability."
      ),
      link: "/services/manufacturing",
    },
    {
      code: "03",
      name: t("list.s3Title", "Test and Qualification"),
      desc: t("list.s3Desc",
        "Complete testing infrastructure for rocket engines and aerospace systems, including real-time data monitoring, chemical laboratory, and structural test bench operations."
      ),
      link: "/services/t8",
    },
    {
      code: "04",
      name: t("list.s4Title", "Launch Systems"),
      desc: t("list.s4Desc",
        "The FTL provides a versatile platform for launch center training, operational readiness exercises, suborbital flight testing, technology qualification, and tactical aerospace missions."
      ),
      link: "/services/ftl",
    },
  ];

  return (
    <PageShell>
      {/* HERO SECTION */}
      <PageHero
        title={t("heroTitle", "Services for the Space Industry")}
        description={t("heroDesc",
          "BIZU Space delivers advanced aerospace solutions in engineering, manufacturing, and testing, ensuring precision, reliability, and high performance in every project."
        )}
        image={heroImage}
      />
      <ProductList products={services} />
    </PageShell>
  );
}
